export default __webpack_public_path__ + "static/media/emptyOrders.b4ac364b.svg";